import { Component, OnInit, Input } from '@angular/core';
import { Group } from 'core/models/group';
import { Game } from 'core/models/game';

@Component({
  selector: 'lms-mars-group-tutorization',
  templateUrl: './mars1-group-tutorization.component.html',
  styleUrls: ['./mars1-group-tutorization.component.scss']
})
export class Mars1GroupTutorizationComponent implements OnInit {
  @Input() group: Group;
  @Input() game: Game;
  public now = Date.now();
  public groupQuestionsListId = 'MARS_GROUP_QUESTIONS_LIST';
  public groupMessagesListId = 'MARS_GROUP_MESSAGES_LIST';
  public groupDebatesListId = 'MARS_GROUP_DEBATES_LIST';
  public filters: Map<string, string>;
  public endDate: number;

  constructor() {}

  ngOnInit(): void {
    this.endDate = new Date(this.group.endDate).getTime();
    this.filters = new Map<string, string>().set('groupId', this.group.id);
  }
}
